  (function () {
    document.querySelectorAll('[data-vgp]').forEach(function (root) {
    var T = JSON.parse(root.querySelector('[data-vgp-i18n]').textContent);
    var data = JSON.parse(root.querySelector('[data-vgp-json]').textContent);
    var form = root.querySelector('[data-vgp-form]'), idInput = root.querySelector('[data-vgp-variant-id]');
    var cta = root.querySelector('[data-vgp-cta]'), ctaLabel = root.querySelector('[data-vgp-cta-label]'), totalEl = root.querySelector('[data-vgp-total]'), miniTotal = root.querySelector('[data-vgp-total-mini]');
    var frames = root.querySelectorAll('[data-vgp-frame]'), thumbs = root.querySelectorAll('[data-vgp-thumb]'), active = 0;
    var locale = root.getAttribute('data-locale') || 'sv', currency = root.getAttribute('data-currency') || 'SEK';
    var digits = currency === 'SEK' ? 0 : 2;
    var fmt; try { fmt = new Intl.NumberFormat(locale === 'en' ? 'en-US' : locale, { style: 'currency', currency: currency, minimumFractionDigits: digits, maximumFractionDigits: digits }); } catch (e) { fmt = null; }
    var money = function (cents) { var v = cents / 100; return fmt ? fmt.format(v) : (v.toFixed(digits) + ' ' + currency); };

    function show(i) {
      if (!frames.length) return; i = (i + frames.length) % frames.length;
      frames[active].classList.remove('is-active'); thumbs[active] && thumbs[active].classList.remove('is-active');
      frames[i].classList.add('is-active'); thumbs[i] && thumbs[i].classList.add('is-active'); active = i;
      if (thumbs[i] && thumbs[i].scrollIntoView) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-vgp-thumb'), 10)); }); });
    root.querySelectorAll('[data-vgp-nav]').forEach(function (b) { b.addEventListener('click', function () { show(active + parseInt(b.getAttribute('data-vgp-nav'), 10)); }); });
    var sx = 0; var stage = root.querySelector('.vgp__stage');
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1)); }, { passive: true });

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-vgp-option]').forEach(function (fs) { var c = fs.querySelector('input:checked'); out.push(c ? c.value : null); });
      return out;
    }
    function findVariant() {
      var opts = selectedOptions(); if (!opts.length) return data.variants[0];
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function qty() { var c = root.querySelector('[data-vgp-qty] input:checked'); return c ? parseInt(c.value, 10) : 1; }
    function addons() { return Array.prototype.slice.call(root.querySelectorAll('[data-vgp-addons] input:checked')); }

    function refresh() {
      var v = findVariant(), n = qty(), add = addons();
      if (v) {
        idInput.value = v.id;
        root.querySelectorAll('[data-vgp-q]').forEach(function (el) { var k = parseInt(el.getAttribute('data-vgp-q'), 10); el.textContent = money(v.price * k) + (k > 1 ? ' · ' + money(v.price) + ' ' + T.each : ''); });
        if (v.featured_media) { var idx = Array.prototype.findIndex.call(frames, function (f) { return String(f.getAttribute('data-media-id')) === String(v.featured_media.id); }); if (idx >= 0) show(idx); }
      }
      var gross = (v ? v.price * n : 0) + add.reduce(function (s, a) { return s + parseInt(a.getAttribute('data-price'), 10); }, 0);
      totalEl.textContent = money(gross); if (miniTotal) miniTotal.textContent = money(gross);
      var ok = v && v.available; cta.disabled = !ok; ctaLabel.textContent = ok ? T.add : (v ? T.soldOut : T.unavailable);
      root.querySelectorAll('[data-vgp-option]').forEach(function (fs, oi) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = selectedOptions(); test[oi] = inp.value;
          var any = data.variants.some(function (vv) { return vv.available && vv.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
          inp.disabled = !any;
        });
      });
    }
    form.addEventListener('change', refresh); refresh();

    form.addEventListener('submit', function (e) {
      e.preventDefault(); var v = findVariant(); if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: qty() }].concat(addons().map(function (a) { return { id: parseInt(a.value, 10), quantity: 1 }; }));
      cta.disabled = true; var old = ctaLabel.textContent; ctaLabel.textContent = T.adding;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { ctaLabel.textContent = T.added; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); setTimeout(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; }, 450); })
        .catch(function () { cta.disabled = false; ctaLabel.textContent = old; alert(T.err); });
    });

    var sticky = root.querySelector('[data-vgp-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting); }, { threshold: 0 }).observe(cta);
      root.querySelector('[data-vgp-sticky-btn]').addEventListener('click', function () { cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  });
  })();
